import React, { Component } from 'react';
import { connect } from "react-redux";
import { Field, reduxForm } from 'redux-form';

import { myHappinessComment } from '../../redux/actions';
import { todayHappiness } from '../../redux/selectors';

import { TooltipSmiley } from '../atoms/tooltip/tooltip';
import Button from '../atoms/button/button';
import { ShortField } from '../atoms/formElements/formElements';
import Quote from '../atoms/quote/quote';

class todayHappinessAnswer extends Component {
  renderForm() {
    let { handleSubmit } = this.props;
    return (
      <form className='flex' onSubmit={handleSubmit(values => this.props.myHappinessComment(values))} >
        <Field name='todayHappiness' placeholder='Optional, add a comment anonymously...' component={ShortField} type='text' />
        <Button label='Send' disabled='false' type='submit' state='small' />
      </form>
    )
  }
  render() {
    let { todayHappiness } = this.props;
    let emojiArray = [];
    let tooltip = ['terrible', 'bad', 'ok', 'good', 'amazing'];
    const img = require(`../assets/emojis/emoji-${todayHappiness.score}.png`);
    if(!todayHappiness.comment) {
      return (
        <div id='todayHappinessAnswer'>
          <div className='flex'>
            <p>You answered the question with: </p>
            <TooltipSmiley position='right' content={tooltip[todayHappiness.score-1]} className='fixed'>
              <img alt='Emoji' src={img} />
            </TooltipSmiley>
          </div>
          {this.renderForm()}
        </div>
      )
    } else {
      return (
        <div id='todayHappinessAnswer'>
          <p className='center small'>(You already answered for today, come back tomorrow!)</p>
          <Quote />
        </div>
      )
    }

  }
}

export default reduxForm({
  // validate,
  form: 'todayHappiness',
})( connect(state => ({todayHappiness: todayHappiness(state)}) , { myHappinessComment })(todayHappinessAnswer));
